import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonImg, IonRow } from '@ionic/react';
import { nanoid } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { Language } from '../../app/common/constants';
import ApplySign from '../controls/applySign';
import { preWorkDisclaimerEN, preWorkDisclaimerSP } from './services/preWorkDisclaimer';
import './css/concent.css';

function PreWorkDisclaimer(props) {
    const [language, setLanguage] = useState("English");
    const [concent, setConcent] = useState(preWorkDisclaimerEN);

    useEffect(() => {
        if (props.language) {
            setLanguage(props.language);
        }
    }, [props.language]);

    useEffect(() => {
        if (language === Language.SPANISH) {
            setConcent(preWorkDisclaimerSP);
        }
        else {
            setConcent(preWorkDisclaimerEN);
        }
    }, [language]);

    let items;
    items = concent.content[0].data.map((item, index) => (
        <li key={nanoid()}>{item}</li>
    ));

    const onSigned = (value) => {
        props.onSigned && props.onSigned(value);
    };

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{concent.title}</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>

                <IonRow>
                    <IonCol>
                        <ol>
                            {items}
                        </ol>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[1].data}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[2].data.replace("###name###", props.name)}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[3].data}
                        </p>
                        <ApplySign
                        buttonText = {language && language == "Spanish" ? "Firma" :  "Sign"}
                            signed={props.signed}
                            signature={props.signature}
                            onSigned={(value) => onSigned(value)} />

                    </IonCol>

                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[4].data}
                        </p>
                        <p className="concent-label-value">
                            {(new Date()).toDateString()}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[5].data}
                        </p>
                        <IonImg src={props.reviewerSignature} className="person-signature" />

                    </IonCol>

                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[6].data}
                        </p>
                        <p className="concent-label-value">
                            {(new Date()).toDateString()}
                        </p>
                    </IonCol>
                </IonRow>

            </IonCardContent>
        </IonCard>
    );
}

export default PreWorkDisclaimer;